import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import Logo from '../Logo.png';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { label: 'Home', href: '#home' },
    { label: 'About', href: '#about' },
    { label: 'Programs', href: '#programs' },
    { label: 'Gallery', href: '#gallery' },
    { label: 'Admissions', href: '#admissions' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-soft">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-20">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <img src="/gallery/logo.png" alt="Kinder Heaven logo" className="h-14 sm:h-16 w-auto object-contain" />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-1 lg:space-x-2">
            {menuItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-gray-700 hover:text-purple-primary font-medium text-sm lg:text-base px-3 lg:px-4 py-2 rounded-lg transition-colors duration-200"
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-2 lg:space-x-4">
            <button onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLSdCRhoQCfF_9QNWPYQ-nPd1UTEWGlL4j7n4XSHVeX-HTE0_-g/viewform?usp=publish-editor', '_blank')} className="bg-purple-primary text-white px-4 lg:px-6 py-2 rounded-lg font-medium text-sm hover:bg-purple-dark transition-colors duration-200">
              Admissions
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-700 hover:text-purple-primary transition-colors"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden pb-4">
            <div className="flex flex-col space-y-2">
              {menuItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="text-gray-700 hover:text-purple-primary hover:bg-pink-light/20 px-3 py-2 rounded-lg transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <button onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLSdCRhoQCfF_9QNWPYQ-nPd1UTEWGlL4j7n4XSHVeX-HTE0_-g/viewform?usp=publish-editor', '_blank')} className="bg-purple-primary text-white px-4 py-2 rounded-lg font-medium w-full hover:bg-purple-dark transition-colors">
                Admissions
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
